export function targetWithCriteo () {
  const criteo = window.crtg_content.split(';')
  criteo.pop()
  if (criteo.length > 0) {
    window.googletag.pubads().setTargeting('crtRTA', criteo)
  }
}



// WEBPACK FOOTER //
// ./src/components/util/ads/utils.js